import React from 'react';
import {
  getProductsTheme,
  setProductsTheme,
  subscribeProductsTheme,
} from './productsThemeStore';

/**
 * Syncs products chrome with the app-wide theme (localStorage + document data-theme).
 * Uses an external store so toggling theme does not re-render the whole products page.
 */
export function useProductsTheme() {
  const themeMode = React.useSyncExternalStore(
    subscribeProductsTheme,
    getProductsTheme,
    () => 'light'
  );

  const setDarkTheme = React.useCallback((isDark) => {
    setProductsTheme(Boolean(isDark));
  }, []);

  return { themeMode, setDarkTheme, isDark: themeMode === 'dark' };
}
